import './styles.styl'
import 'react-toggle/style.css'

import React from 'react'
// import Autocomplete from 'react-autocomplete'
import Toggle from 'react-toggle'

export default class SettingsUsers extends React.Component {
  constructor (props) {
    super(props)

    let state = {
      usersActive: false,
      usersMigrationAdd: true,
      usersMigrationMutate: false,
      usersMigrationDestroy: false,
      usersMigrationDeactivate: false,
      managersActive: false,
      managersMigrationAdd: true,
      managersMigrationMutate: false,
      managersMigrationDestroy: false,
      managersMigrationDeactivate: false
    }

    if (props.data !== null) {
      state = {
        ...state,
        ...props.data
      }
    }

    this.state = state
  }

  slugify (text) {
    return String(text)
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w-]+/g, '') // Remove all non-word chars
      .replace(/--+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  }

  saveAndToggle (index) {
    this.props.save({ ...this.state })
    this.props.toggleSection(index)
  }

  saveAndNext (index) {
    this.props.save({ ...this.state })
    this.props.nextSection(index)
  }

  render () {
    const index = this.props.index
    const content = []

    content.push(
      <div key={content.length} className='row subsection no-margin'>
        <div className='col-12 col-sm-4'>
          <label className='form-label'>Gebruikers importeren</label>
        </div>

        <div className='col-12 col-sm-8'>
          <input
            type='file'
            className='form-control-file form-control-sm'
            placeholder='Selecteer een CSV bestand.'
          />
        </div>
      </div>
    )

    content.push(
      <div key={content.length} className='row subsection no-margin'>
        <div className='col-12 col-sm-4'>
          &nbsp;
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch'>
            <Toggle
              checked={this.state.usersActive}
              onChange={e => this.setState({ usersActive: e.target.checked })}
            />
            <span>Gebruikers actief na importeren</span>
          </div>
        </div>
      </div>
    )

    content.push(
      <div key={content.length} className='row subsection no-margin'>
        <div className='col-12 col-sm-4'>
          &nbsp;
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch'>
            <Toggle
              checked={this.state.usersMigrationMutate}
              onChange={e => this.setState({ usersMigrationMutate: e.target.checked })}
            />
            <span>Pas bestaande gebruikers aan bij importeren</span>
          </div>
        </div>
      </div>
    )

    content.push(
      <div key={content.length} className='row subsection no-margin'>
        <div className='col-12 col-sm-4'>
          &nbsp;
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch'>
            <Toggle
              checked={this.state.usersMigrationDestroy}
              onChange={e => {
                const checked = e.target.checked
                const state = { usersMigrationDestroy: checked }
                if (checked === true) {
                  state.usersMigrationDeactivate = false
                }
                this.setState(state)
              }}
            />
            <span>Vernietig ontbrekende bestaande gebruikers bij importeren</span>
          </div>
        </div>
      </div>
    )

    content.push(
      <div key={content.length} className='row subsection'>
        <div className='col-12 col-sm-4'>
          &nbsp;
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch'>
            <Toggle
              checked={this.state.usersMigrationDeactivate}
              onChange={e => {
                const checked = e.target.checked
                const state = { usersMigrationDeactivate: checked }
                if (checked === true) {
                  state.usersMigrationDestroy = false
                }
                this.setState(state)
              }}
            />
            <span>Deactiveer ontbrekende bestaande gebruikers bij importeren</span>
          </div>
        </div>
      </div>
    )

    content.push(
      <div key={content.length} className='row subsection no-margin'>
        <div className='col-12 col-sm-4'>
          <label className='form-label'>Beheerders importeren</label>
        </div>

        <div className='col-12 col-sm-8'>
          <input
            type='file'
            className='form-control-file form-control-sm'
            placeholder='Selecteer een CSV bestand.'
          />
        </div>
      </div>
    )

    content.push(
      <div key={content.length} className='row subsection no-margin'>
        <div className='col-12 col-sm-4'>
          &nbsp;
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch'>
            <Toggle
              checked={this.state.managersActive}
              onChange={e => this.setState({ managersActive: e.target.checked })}
            />
            <span>Beheerders actief na importeren</span>
          </div>
        </div>
      </div>
    )

    content.push(
      <div key={content.length} className='row subsection no-margin'>
        <div className='col-12 col-sm-4'>
          &nbsp;
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch'>
            <Toggle
              checked={this.state.managersMigrationMutate}
              onChange={e => this.setState({ managersMigrationMutate: e.target.checked })}
            />
            <span>Pas bestaande beheerders aan bij importeren</span>
          </div>
        </div>
      </div>
    )

    content.push(
      <div key={content.length} className='row subsection no-margin'>
        <div className='col-12 col-sm-4'>
          &nbsp;
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch'>
            <Toggle
              checked={this.state.managersMigrationDestroy}
              onChange={e => {
                const checked = e.target.checked
                const state = { managersMigrationDestroy: checked }
                if (checked === true) {
                  state.managersMigrationDeactivate = false
                }
                this.setState(state)
              }}
            />
            <span>Vernietig ontbrekende bestaande beheerders bij importeren</span>
          </div>
        </div>
      </div>
    )

    content.push(
      <div key={content.length} className='row subsection'>
        <div className='col-12 col-sm-4'>
          &nbsp;
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch'>
            <Toggle
              checked={this.state.managersMigrationDeactivate}
              onChange={e => {
                const checked = e.target.checked
                const state = { managersMigrationDeactivate: checked }
                if (checked === true) {
                  state.managersMigrationDestroy = false
                }
                this.setState(state)
              }}
            />
            <span>Deactiveer ontbrekende bestaande beheerders bij importeren</span>
          </div>
        </div>
      </div>
    )

    return (
      <section key={index} className={['section', (this.props.open ? 'section-open' : 'section-closed')].join(' ')}>
        <div className='row section-title'>
          <div className='col-10'>
            <h3>Gebruikers</h3>
          </div>

          <div className='col-2 text-align-right'>
            <a href='#' onClick={() => this.saveAndToggle(index)} className='edit-link'>{this.props.open ? 'Sluiten' : 'Bewerken'}</a>
          </div>
        </div>

        <div className='row section-content'>
          <div className='col-12 col-lg-10'>
            {content}
          </div>
        </div>

        <div className='row section-buttons'>
          <div className='col-12 text-align-right'>
            <button className='btn btn-sm btn-secondary btn-rounded' onClick={() => this.saveAndNext(index)}>Volgende &raquo;</button>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/projects/create/settings-users.js